import { useState, useEffect } from 'react';
import { useClassroomApi } from '../api/classroomApi';

export const useClassrooms = () => {
  const [classrooms, setClassrooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAllClassrooms } = useClassroomApi();

  const fetchClassrooms = async () => {
    setLoading(true);
    setError(null);
    
    const { data, error: apiError } = await getAllClassrooms();
    
    if (apiError) {
      setError(apiError);
    } else {
      setClassrooms(data);
    }
    
    setLoading(false);
  };

  useEffect(() => {
    fetchClassrooms();
  }, []);

  return {
    classrooms,
    loading,
    error,
    refetch: fetchClassrooms,
  };
};